import { render, staticRenderFns } from "./updateChain.vue?vue&type=template&id=1fc6fa01&scoped=true&"
import script from "./updateChain.vue?vue&type=script&lang=js&"
export * from "./updateChain.vue?vue&type=script&lang=js&"
import style0 from "./updateChain.vue?vue&type=style&index=0&id=1fc6fa01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6fa01",
  null
  
)

export default component.exports